export default __webpack_public_path__ + "static/media/workflow_plus.3419b278.svg";